module.exports = __webpack_public_path__ + "img/source4.ef1973a5.png";